import { Button, Card, Form, Select, Space, TimePicker } from 'antd'
import { Option } from 'antd/es/mentions';
import React, { useEffect, useState } from 'react'
import PageHeading from '../../../../../components/common/PageHeading'
import { Input } from 'antd';
import { CloseCircleOutlined, CloseSquareOutlined, PlusCircleFilled, PlusCircleOutlined } from '@ant-design/icons';
import { eligibleCharge } from '../../../../../utils/NewPropertyHelper';
import '../../components/AllGuestCards.css';



const TuesdayCard = (props) => {
    const [showIt, setShowIt] = useState(false);
    const [showList, setShowList] = useState(false);
    const [errors, setErrors] = useState([]);
    const [serviceList, setServiceList] = useState([
        {
            startTime: null,
            endTime: null,
            option: '',
            confirmDelete: false,
        },

    ]);
    const timeFormat = "HH:mm:ss";

    const handleChange = (index, key, value) => {
        //console.log("index=>", index, "key=>", key, "value=>", value)
        const newData = [...serviceList];
        // console.log("new=>", serviceList)
        // console.log("newData=>", newData)
        newData[index][key] = value;
        setServiceList(newData);
        // localStorage.setItem("serviceList", JSON.stringify(newData));


    };

    const addMoreAvailability = () => {
        // console.log("serviceList.length", serviceList.length)

        if (serviceList.length < 1) {
            setServiceList([
                {
                    startTime: null,
                    endTime: null,
                    option: '',
                    confirmDelete: false,
                },
            ])
        }

        else {
            setServiceList([
                ...serviceList,
                {
                    startTime: null,
                    endTime: null,
                    option: '',
                    confirmDelete: false,
                },
            ]);
        }

    }
    const deleteAvailability = (index) => {
        const newData = [...serviceList];
        const item = newData[index];
        if (!item.confirmDelete) {
            item.confirmDelete = true;
        } else {
            newData.splice(index, 1);

            setServiceList(newData);

        }
        setServiceList(newData);
    };

    const cancelButton = () => {
        setShowIt(false);
        setServiceList([
            ...serviceList
        ]);
    }
    const { Search } = Input;

    const onFinish = (values) => {
        if (serviceList.length < 1) {
            setShowIt(false)
        }

        serviceList.map((service, index) => {
            console.log("foreach", service);
            if (service.startTime && service.endTime && service.option) {


                if (service.startTime >= service.endTime) {

                    let newErrors = [...errors];
                    newErrors[index] = {
                        message: "Start time should be before end time",
                        startTime: true,
                        endTime: true,
                        option: false
                    };
                    setErrors(newErrors);
                } else {
                    let newErrors = [...errors];
                    newErrors[index] = {};
                    setErrors(newErrors);
                    setShowList(true);
                    setShowIt(false);
                }
            } else {
                let newErrors = [...errors];
                newErrors[index] = {
                    message: "All fields are required",
                    startTime: true,
                    endTime: true,
                    option: true
                };
                setErrors(newErrors);
            }
        });
    };
    const editButton = () => {
        setShowIt(true)
        // if (serviceList.length < 1) {
        //     setServiceList([]);
        // }
    }
    useEffect(() => {
        if (serviceList.length < 1) {
            setServiceList([
                {
                    startTime: null,
                    endTime: null,
                    option: '',
                    confirmDelete: false,
                },
            ])
        }
    }, [showIt]);


    return (
        <Card
            className='bg-shadow'
            size="large"
            title={props.title}
            extra={<a onClick={editButton}>{!showIt && "Edit"}</a>}
            style={{
                width: '100%'
            }}>

            {!showIt && !showList && <p style={{ textAlign: 'center' }}>
                Not Available
            </p>}


            {showList && !showIt && serviceList.length >= 1 && serviceList.map((item, index) => (
                item.startTime && item.endTime ? (
                    <p style={{ textAlign: 'center' }} key={index}>
                        Available: {item.startTime.format(timeFormat)} to {item.endTime.format(timeFormat)} {item.option}
                    </p>
                ) : <p style={{ textAlign: 'center' }} >Not Available</p>
            ))}

            <Form layout="vertical" onFinish={onFinish}>
                {showIt && serviceList.map((singleService, index) => (

                    <Space key={index} style={{ display: 'flex', justifyContent: 'end', margin: '30px 0px' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Form.Item
                                    name="Available"
                                    label="Available"

                                >

                                </Form.Item>
                                <div style={{ display: 'flex', flexDirection: 'column', margin: '0px 10px' }}>

                                    <Form.Item
                                        name={`startTime-${index}`}
                                        label="Start Time *"

                                    >
                                        <TimePicker placeholder="Enter a Time"
                                            inputReadOnly use12Hours
                                            onChange={(value) => handleChange(index, "startTime", value)}
                                            // style={{ width: '300px' }}
                                            style={{
                                                width: '300px',
                                                borderColor: errors[index]?.startTime ? "red" : ""
                                            }}

                                        />

                                    </Form.Item>
                                    {errors[index]?.startTime && <div style={{ color: "red", display: 'flex', justifyContent: 'center' }}>{errors[index].message}</div>}

                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', margin: '0px 10px' }}>
                                    <Form.Item
                                        name={`endTime-${index}`}

                                        label="End Time *"
                                    >
                                        <TimePicker placeholder="Enter a Time" inputReadOnly use12Hours
                                            format="h:mm:ss A" onChange={(value) => handleChange(index, "endTime", value)}
                                            // style={{ width: '300px' }}
                                            style={{ width: '300px', borderColor: errors[index]?.endTime ? "red" : "" }}
                                        />

                                    </Form.Item>
                                    {errors[index]?.endTime && <div style={{ color: "red", display: 'flex', justifyContent: 'center' }}>{errors[index].message}</div>}

                                </div>

                            </div>

                            <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'end', flexDirection: 'column', margin: '10px' }}>
                                <Form.Item
                                    name={`option-${index}`}
                                    label="Property or group of property *"

                                >
                                    <Select
                                        showSearch
                                        options={eligibleCharge}
                                        onChange={(value) => handleChange(index, "option", value)}
                                        initialvalues={eligibleCharge[0]}
                                        style={{ width: '620px', borderColor: errors[index]?.option ? "red" : "" }}
                                        placeholder="Search by Property or Proprty Group" />

                                </Form.Item>
                                {errors[index]?.option && <div style={{
                                    color: "red", display: 'flex',
                                    justifyContent: 'center'
                                }}>{errors[index].message}</div>}

                            </div>
                        </div>

                        <Button
                            className="show-avail-delete" style={{
                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                height: '140px', margin: '10px',
                            }} danger
                            icon={!singleService.confirmDelete ? <CloseCircleOutlined /> : " "}
                            onClick={() => deleteAvailability(index)}
                        >
                            {singleService.confirmDelete ? 'Delete' : ''}
                        </Button>
                    </Space>
                ))
                }
                {showIt &&
                    <Form.Item>
                        <Button className="add-moreAvail" onClick={addMoreAvailability} size={"small"}
                            icon={<i className="fa-solid fa-circle-plus" ></i>}> Add More Availability
                        </Button>
                    </Form.Item>
                }

                {
                    showIt && <div className="form-action page-actions-container" style={{ display: 'flex' }}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">Save
                            </Button>
                        </Form.Item>
                        <Form.Item>
                            <Button
                                onClick={cancelButton}>Cancel</Button>
                        </Form.Item>
                    </div>
                }

            </Form>
        </Card>


    )
}

export default TuesdayCard;

